import { I18nComponente } from "@/types/gerais"

export const OIniciarAtividadeRealizadaNaoPlanejadai18n: I18nComponente = {
  "pt-BR": {
    iniciarNovaAtividade: "iniciar nova atividade",
    projetos: "projetos",
    tipoDeAtividade: "tipo de atividade",
    voltar: "voltar",
    iniciar: "iniciar",
    erroAoBuscarProjetos: "Erro ao buscar projetos",
    erroAoBuscarAtributos: "Erro ao buscar atributos",
    ocorreuUmErroAoBuscarProjetos: "Ocorreu um erro ao buscar os projetos, tente novamente mais tarde.",
    ocorreuUmErroAoBuscarAtributos: "Ocorreu um erro ao buscar os atributos, tente novamente mais tarde.",
    projetoNaoPossuiAtividadesPlanejadas: "Projeto não possui atividades planejadas",
    selecioneOutroProjeto: "Selecione outro projeto.",
    atividadeIniciadaComSucesso: "Atividade iniciada com sucesso!",
    calendarioEstaSendoAtualizado: "O calendário esta sendo atualizado.",
    erroAoIniciarAtividade: "Erro ao iniciar atividade!",
    tenteNovamenteMaisTarde: "Tente novamente mais tarde.",
    etapaAtividade: "Atividade",
    etapaAtributos: "Atributos",
    atributosComValoresInvalidos: "Atributos com valores inválidos",
    obrigatorioPreencherAtributos: "É obrigatório preencher todos os atributos com valores válidos",
  },  
  "es-CO": {
    iniciarNovaAtividade: "iniciar nueva actividad",
    projetos: "proyectos",
    tipoDeAtividade: "tipo de actividad",
    voltar: "volver",
    iniciar: "iniciar",
    erroAoBuscarProjetos: "Error al buscar proyectos",
    erroAoBuscarAtributos: "Error al buscar atributos",
    ocorreuUmErroAoBuscarProjetos: "Ocurrió un error al buscar los proyectos, inténtelo de nuevo más tarde.",
    ocorreuUmErroAoBuscarAtributos: "Ocurrió un error al buscar los atributos, inténtelo de nuevo más tarde.",
    projetoNaoPossuiAtividadesPlanejadas: "El proyecto no tiene actividades planeadas",
    selecioneOutroProjeto: "Seleccione otro proyecto.",
    atividadeIniciadaComSucesso: "¡Actividad iniciada con éxito!",
    calendarioEstaSendoAtualizado: "El calendario se está actualizando.",
    erroAoIniciarAtividade: "¡Error al iniciar actividad!",
    tenteNovamenteMaisTarde: "Inténtalo de nuevo más tarde.",
    etapaAtividade: "Actividad",
    etapaAtributos: "Atributos",
    atributosComValoresInvalidos: "Atributos con valores inválidos",
    obrigatorioPreencherAtributos: "Es obligatorio completar todos los atributos con valores válidos",
  },
}
